import * as React from "react";
import styled from "styled-components";
import { useTl } from "../../hooks";
import { ETLCodes } from "../../locales";
import { Link } from "react-router-dom";
import moment from "moment";

export interface IRequestInformationsDisplayProps {
  requestNumber: string;
  requestType: string;
  requestDate: Date;
  requestStatus: string;
  requestPrice: number;
  bill: any;
}

const Container = styled.div`
  width: 50%;
  margin: auto;
  margin-bottom: 1rem !important;
  border: 2px solid #a1a1a1;
  padding: 1rem;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
`;

const InfoContainer = styled.div`
  display: flex;
  justify-content: space-around;
`;
const FlexContainer = styled.div`
  display: flex;
`;

const BoldContainer = styled.div`
  font-weight: bold;
  margin-left: 0.5rem;
`;

export const RequestInformationsDisplay: React.FunctionComponent<IRequestInformationsDisplayProps> = ({
  requestNumber,
  requestType,
  requestDate,
  requestStatus,
  requestPrice,
  bill,
}) => {
  const { t } = useTl();

  return (
    <Container>
      <div style={{ fontSize: "25px", marginBottom: "1rem" }}>{` ${t(ETLCodes.Request)} ${requestNumber}`}</div>
      <div style={{ fontSize: "20px", marginBottom: "1rem" }}>{requestType}</div>
      <FlexContainer style={{ fontSize: "15px", marginBottom: "1rem" }}>
        {t(ETLCodes.RequestDate)}
        <BoldContainer>{moment(requestDate).format("DD/MM/YYYY")}</BoldContainer>
      </FlexContainer>
      <InfoContainer>
        <FlexContainer>
          {`${t(ETLCodes.Status)}: `} <BoldContainer>{requestStatus}</BoldContainer>
        </FlexContainer>
        {requestPrice && (
          <FlexContainer>
            {`${t(ETLCodes.Price)}: `} <BoldContainer>{requestPrice}</BoldContainer>
          </FlexContainer>
        )}

        {bill && <Link to={bill}>{t(ETLCodes.Bill)}</Link>}
      </InfoContainer>
    </Container>
  );
};
